/**
 * Returns navigation options for the left sidebar
 */
export const getNavigationOptions = (): {
  id: string
  label: string
  link: string
}[] => {
  return [
    {
      id: '1',
      label: 'Manage Dashboards',
      link: '#manage-dashboards',
    },
    {
      id: '2',
      label: 'Manage SE Metrics Programs',
      link: '#manage-se-metrics',
    },
    {
      id: '3',
      label: 'Manage Global SE Metrics KPI',
      link: '#manage-global-se-metrics-kpi',
    },
  ]
}

// Define breadcrumb items
export const getBreadcrumbItems = () => [
  {id: 'home', label: 'Home', href: '/'},
  {id: 'metrics-settings', label: 'Metrics Settings', href: '/metrics-settings'},
]
